/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `CALENDAR_DAYS` - Calendar days
* `WORKING_DAYS` - Working days
 */
export type FreetimeCountTypeEnum = typeof FreetimeCountTypeEnum[keyof typeof FreetimeCountTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FreetimeCountTypeEnum = {
  CALENDAR_DAYS: 'CALENDAR_DAYS',
  WORKING_DAYS: 'WORKING_DAYS',
} as const;
